var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.5312,
    y: 17.625,
    width: 16.0625,
    height: 15.25,
    rx: 7.625,
    transform: "rotate(180 18.5312 17.625)",
    stroke: "#F94444"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3516 13.5898C11.3516 14.0749 11.0679 14.3174 10.5005 14.3174C9.93311 14.3174 9.64941 14.0749 9.64941 13.5898C9.64941 13.3587 9.72119 13.1781 9.86475 13.0479C10.0049 12.9209 10.2168 12.8574 10.5005 12.8574C11.0679 12.8574 11.3516 13.1016 11.3516 13.5898ZM9.72119 6.71973L11.2849 6.71973L11.2849 11.8876L9.72119 11.8876L9.72119 6.71973Z",
    fill: "#F94444"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/ERROR.d80e86b6586e9bf5d75590acb52c6f9a.svg";
export { ForwardRef as ReactComponent };